import { useCallback, useState } from 'react';
import { useQueryParams } from '@/hooks/useQueryParams';
import { MagicJobType } from '@/types/gql.generated';

const isMagicJobType = (value: unknown): value is MagicJobType => {
  return (
    typeof value === 'string' &&
    Object.values(MagicJobType).includes(value as MagicJobType)
  );
};

export const useInitialPromptType = (overridePromptType?: MagicJobType) => {
  const { queryParams } = useQueryParams();

  const [promptType, setPromptType] = useState<MagicJobType>(() => {
    const initialPromptType = (
      queryParams.get('initialPromptType') ?? ''
    ).toUpperCase();

    return isMagicJobType(initialPromptType)
      ? initialPromptType
      : overridePromptType || MagicJobType.Text;
  });

  const setPromptTypeWrapper = useCallback(
    (promptType: MagicJobType | undefined) => {
      setPromptType(promptType ?? MagicJobType.Text);
    },
    []
  );

  return {
    promptType,
    setPromptType: setPromptTypeWrapper,
  };
};
